/** Matches Avatarable#acceptable_avatar in app/models/concerns/avatarable.rb */
export const INBOX_AVATAR_ACCEPT =
  'image/png,image/jpeg,image/jpg,image/gif,image/webp';

export const INBOX_AVATAR_ALLOWED_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
];

export const INBOX_AVATAR_MAX_BYTES = 15 * 1024 * 1024;

export const validateInboxAvatarFile = file => {
  if (!file) {
    return { valid: false, errorKey: 'FILE_TYPE_ERROR' };
  }

  const baseType = (file.type || '').split(';')[0].trim().toLowerCase();
  if (!INBOX_AVATAR_ALLOWED_TYPES.includes(baseType)) {
    return { valid: false, errorKey: 'FILE_TYPE_ERROR' };
  }

  if (file.size > INBOX_AVATAR_MAX_BYTES) {
    return { valid: false, errorKey: 'FILE_SIZE_ERROR' };
  }

  return { valid: true };
};
